import React, { useContext, useEffect, useState } from "react";

import Button from "../components/Button/Button";
import SvgIcon from "../components/Icon/SvgIcon";

import UModal from "../components/Modals/UModal";
import WrapperContainer from "../components/WrapperContainer/WrapperContainer";

import USelect from "../components/Select/USelect";
import CityListContext from "../context/cityList";

const ModalSupport = () => {
  const cityList = useContext(CityListContext);
  const [selectedCity, setSelectedCity] = useState({});

  const [isOpenModal, setIsOpenModal] = useState(false);

  /**
   * При каждом открытии модального окна с поддержкой отображать город по умолчанию
   */
  useEffect(() => {
    if (isOpenModal) {
      setSelectedCity({
        alias: "ufa",
        title: "Уфа",
        short_phone: "+7 347 290 04 05",
        phone: "09388",
      });
    }
  }, [isOpenModal]);

  return (
    <>
      <div className="support-float-container">
        <div className="support-float-button">
          <Button size="sm" onClick={() => setIsOpenModal(true)}>
            <SvgIcon isAccent name="headset" />
            Поддержка
          </Button>
        </div>
      </div>

      {isOpenModal && (
        <UModal
          isOpenModal={isOpenModal}
          modalTitle="Обратитесь в офис"
          closeModal={() => setIsOpenModal(false)}
        >
          <WrapperContainer gap="24" text="lg">
            Позвоните нам и наш специалист поможет вам
          </WrapperContainer>

          <WrapperContainer gap="16">
            <USelect
              isSearchable
              options={cityList}
              getOptionValue={option => option.alias}
              getOptionLabel={option => option.title}
              onChange={city => setSelectedCity(city)}
              value={selectedCity}
            />
          </WrapperContainer>

          <WrapperContainer align="center">
            <a href={`tel:${selectedCity.short_phone}`} className="link text-phone-number">
              {selectedCity.short_phone}
            </a>
          </WrapperContainer>
          <WrapperContainer gap="16" align="center" text="md" className="text-color-dark-gray">
            Бесплатно для МТС, Билайн, Мегафон, Теле2
          </WrapperContainer>
          <WrapperContainer align="center">
            <a href={`tel:${selectedCity.phone}`} className="link text-phone-number">
              {selectedCity.phone}
            </a>
          </WrapperContainer>
          <WrapperContainer align="center" text="md" className="text-color-dark-gray">
            Для всего остального. По тарифу оператора
          </WrapperContainer>
        </UModal>
      )}
    </>
  );
};

export default ModalSupport;
